<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '../../design-system/utils';

interface Props {
  width?: string;
  height?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
  variant?: 'text' | 'rect' | 'circle';
}

const props = withDefaults(defineProps<Props>(), {
  rounded: 'md',
  variant: 'rect',
});

const style = computed(() => ({
  width: props.width,
  height: props.height || (props.variant === 'text' ? '1em' : '1.25rem'),
}));

const classes = computed(() =>
  cn(
    'ds-skeleton bg-bg-muted relative overflow-hidden',
    props.variant === 'circle' ? 'rounded-full aspect-square' : `rounded-${props.rounded}`,
  ),
);
</script>

<template>
  <div :class="classes" :style="style" aria-hidden="true" />
</template>

<style scoped>
.ds-skeleton::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--ds-shimmer-overlay) 50%,
    transparent 100%
  );
  animation: ds-shimmer 1.4s ease-in-out infinite;
  transform: translateX(-100%);
}

@keyframes ds-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
